/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import Dialog, { dialogClasses, DialogProps } from "@mui/material/Dialog";

const DEFAULT_MAX_WIDTH = 500;

export type DialogBaseProps = Omit<DialogProps, "maxWidth" | "fullWidth" | "disableBackdropClick"> & { maxWidth?: string | number };

export default function DialogBase(props: DialogBaseProps) {
    const { children, scroll, maxWidth, ...restProps } = props;
    return (
        <Dialog
            {...restProps}
            fullWidth
            sx={[
                {
                    [`.${dialogClasses.paper}`]: {
                        maxWidth: maxWidth !== undefined ? maxWidth : DEFAULT_MAX_WIDTH
                    }
                },
                ...(props.sx !== undefined ? (Array.isArray(props.sx) ? props.sx : [props.sx]) : []),
            ]}
            scroll={typeof scroll !== "undefined" ? scroll : "body"}
            onClose={(evt, reason) => {
                if (reason !== "backdropClick") {
                    props.onClose?.(evt, reason);
                }
            }}
        >
            {children}
        </Dialog>
    );
}